<template>
  <!--
      	作者：luo
      	时间：2020-09-15
      	描述：插件中心-封坛
      -->
  <div class="user">
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName">
        <el-tab-pane label="封坛信息详情" name="article">
          <Article v-if="activeName=='article'"></Article>
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>

<script>
  import FengtanApi from '@/api/fengtan.js';
  import Article from './feng/Index.vue';

  export default {
    components: {
      Article,

    },
    data() {
      return {
        activeName: 'article',
        /*是否加载完成*/
        loading: true,
      }
    },
    created() {


    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/plus/feng/index.vue